var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisaLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 13,
    viewBox: "0 0 41 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_164_2124)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.7048 0.015625C23.7936 0.015625 21.1921 1.48864 21.1921 4.21016C21.1921 7.3312 25.806 7.54675 25.806 9.11468C25.806 9.77486 25.031 10.3659 23.7073 10.3659C21.8287 10.3659 20.4247 9.54008 20.4247 9.54008L19.8239 12.2864C19.8239 12.2864 21.4414 12.9839 23.5888 12.9839C26.7716 12.9839 29.2761 11.4385 29.2761 8.67056C29.2761 5.37259 24.643 5.16342 24.643 3.70815C24.643 3.19091 25.2791 2.62428 26.5991 2.62428C28.0883 2.62428 29.3033 3.22485 29.3033 3.22485L29.8913 0.572404C29.8913 0.572404 28.5692 0.015625 26.7048 0.015625ZM0.0705085 0.215828L0 0.616195C0 0.616195 1.22475 0.834988 2.32781 1.27149C3.74807 1.77198 3.84928 2.06337 4.08847 2.96835L6.69498 12.7775H10.1891L15.5721 0.215828H12.086L8.62711 8.75654L7.21571 1.51701C7.08627 0.688471 6.4306 0.215828 5.62804 0.215828H0.0705085ZM16.9739 0.215828L14.2391 12.7774H17.5634L20.2886 0.215788H16.9739V0.215828ZM35.5145 0.215828C34.7129 0.215828 34.2882 0.634785 33.9766 1.36689L29.1063 12.7774H32.5924L33.2668 10.8756H37.5139L37.9241 12.7774H41L38.3165 0.215828H35.5145ZM35.9679 3.60959L37.0013 8.32332H34.2329L35.9679 3.60959Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_164_2124"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 13,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaLogo);
export default __webpack_public_path__ + "static/media/visa-logo.48b028ac1885dc876d48ccf7cd2e0527.svg";
export { ForwardRef as ReactComponent };